const MIN_TERM_LEN = 3;
export const tokenize = (text) => text
    .toLowerCase()
    .split(/[^0-9a-zа-я-]+/)
    .filter((token) => token.length >= MIN_TERM_LEN && !/[0-9a-z]/.test(token));
//# sourceMappingURL=tokenize.js.map